import React from 'react';
import GeneralPrinciples from './GeneralPrinciples';
import SpecificSituations from './SpecificSituations';
import Web3Techniques from './Web3Techniques';
import MigrationConsiderations from './MigrationConsiderations';

const PromptEngineering = () => {
  return (
    <section className="mb-16">
      <h2 className="text-3xl font-bold text-gray-800 mb-6">ASI1 Prompt Engineering Best Practices</h2>
      <div className="bg-blue-50 p-6 rounded-lg border border-blue-100 mb-8">
        <p className="text-gray-700 leading-relaxed">
          This guide provides specific prompt engineering techniques for ASI1 models to help you achieve optimal results in your Web3 and agentic AI applications. These models have been trained for precise instruction following and autonomous decision-making in decentralized environments.
        </p>
      </div>

      <GeneralPrinciples />
      <SpecificSituations />
      <Web3Techniques />
      <MigrationConsiderations />

      <div className="bg-gradient-to-r from-blue-50 to-blue-100 p-6 rounded-lg border border-blue-200 text-center">
        <h4 className="font-semibold text-gray-800 mb-3">Ready to optimize your ASI1 prompts?</h4>
        <p className="text-gray-700 text-sm mb-4">
          Apply these techniques to unlock the full potential of ASI1's Web3-native and agentic AI capabilities in your decentralized applications.
        </p>
        <a 
          href="https://docs.asi1.ai/docs/"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-blue-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-blue-700 transition-colors inline-block text-sm"
        >
          Explore Advanced Documentation
        </a>
      </div>
    </section>
  );
};

export default PromptEngineering;
